module.exports = __webpack_public_path__ + "static/img/img-kf4.43f78b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-kf4.png
// module id = SMyn
// module chunks = 0